import React, { Component } from "react";

import InputMask from "./InputMask";
import PropType from "prop-types";

export default class CurrencyField extends Component {
  static propTypes = {
    onChangeEvent: PropType.func,
    innitialValue: PropType.number,
    fieldValue: PropType.any
  };

  state = {
    value: this.props.fieldValue
  };

  handleChange = value => {
    /** Chama uma função custom de onChange */
    if (this.props.onChangeEvent) this.props.onChangeEvent(value);

    this.setState({
      value: value
    });
  };

  UNSAFE_componentWillReceiveProps(props) {
    const value = props.value;

    if (value != null) {
      this.setState({
        value
      });
    }
  }

  componentDidMount() {
    if (this.props.innitialValue) {
      this.setState({
        value: this.props.innitialValue
      });
    }
  }

  render() {
    /** Evita de passar propriedades inválidas para o componente Input */
    const rest = Object.assign({}, this.props);
    delete rest.onChangeEvent;
    delete rest.innitialValue;
    delete rest.value;

    return (
      <InputMask
        value={this.state.value}
        onChangeEvent={this.handleChange}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CurrencyField/index.js